import { Component, OnInit, TemplateRef } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router, Data } from '@angular/router';
import { TSFuntionService } from '../../services/ts-funtion.service';
import * as _ from 'lodash';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-admin-task',
  templateUrl: './admin-task.component.html',
  styleUrls: ['./admin-task.component.css']
})

export class AdminTaskComponent implements OnInit {
  modalRef: BsModalRef;
  constructor(
    private http: HttpClient,
    private router: Router,
    private System: TSFuntionService,
    private modalService: BsModalService,
  ) { } //

  public settings = {};

  ResultPermission: boolean = true;
  isResult: boolean = false;
  arrGL: any;
  settings_com = {};
  async ngOnInit() {
    this.settings = {
      singleSelection: false,
      idField: 'sValue',
      textField: 'sText',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settings_com = {
      singleSelection: false,
      idField: 'COMPANY_CODE',
      textField: 'COMPANY_NAME',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.ResultPermission = await this.System.CheckPermissionMeun(11); //F = ดู, T = แก้ 
    if (this.ResultPermission == false) {
      this.isResult = true;
    }
    else {
      this.isResult = false;
    }
    let ua = this.System.GetUserStorage();
    if (ua) {
      this.FilterGrid.sCompanyCode = [];
      ua.lstCompCode.forEach(f =>
        this.FilterGrid.sCompanyCode.push({ COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName })
      );
    }
    this.FilterGrid.nStatusID = [{ "sValue": 8, "sText": "Waiting Verify" }];
    this.loadData();
    this.SetDataOnPageLoad();
 
  }



  //#region GetFilter Data
  _RequestType = [];
  _Status = [];
  _Company = [];

  SetDataOnPageLoad() {
    //Type
    this.http.get<any>(this.System.SiteName + "api/AdminTask/GetTaskType").subscribe(res => {
      this._RequestType = res;
    });
    //Status
    this.http.get<any>(this.System.SiteName + "api/AdminTask/GetTaskStatus").subscribe(res => {
      this._Status = res;
    });

    this.http.get<any>(this.System.SiteName + "api/Search/GetCompany").subscribe(res => {
      if (res) {
        this._Company = res;
      }
    });
  }

  //#endregion

  //#region Table
  //#region 1. ตัวแปรในการทำงาน
  //Standard Data Grid
  FilterGrid = {
    sSearch: "",
    nReqType: [],
    nStatusID: [],
    sCompanyCode: [],
    dDate: [],
    nUrgent: "",
  }
  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 }
    ]
  }
  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortDesc = "fas fa-sort-down";
  IcoSortAsc = "fas fa-sort-up";
  sDetailData = "";
  _ArrData = [];
  _ArrDataBind = [];
  //#endregion

  //#region 2. Header Colomn
  Columns = [
    { ColumnName: "", SortField: "", Width: "4%" },
    { ColumnName: "", SortField: "", Width: "3%" },
    { ColumnName: "Req. No.", SortField: "sRequestCode", Width: "12%" },
    { ColumnName: "Type", SortField: "sReqType", Width: "15%" },
    { ColumnName: "Vendor / Customer Name", SortField: "sVendorName", Width: "22%" },
    { ColumnName: "", SortField: "", Width: "3%" },
    { ColumnName: "Due Date", SortField: "dDueDate", Width: "9%" },
    { ColumnName: "Net Total", SortField: "nTotalAmount", Width: "13%" },
    { ColumnName: "Cur.", SortField: "sCurrency", Width: "5%" },
    { ColumnName: "Status", SortField: "sStatusName", Width: "16%" }
  ]
  //#endregion

  //#region Event
  //Event ตอนกด Click Header
  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      }
      else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrData = _.orderBy(this._ArrData, [SortField], [this.SortDirection]);
      this.BindDataTable();
    }
  }

  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });
  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }
  //#endregion

  loadData() {
    this.OptionGrid.nCurrentPage = 1;
    this.System.BlockUI();
    //let data: any;
    let _sReqType: string = this.FilterGrid.nReqType.length > 0 ? this.FilterGrid.nReqType.map(e => e.sValue).join(",") : "";
    let _sStatus: string = this.FilterGrid.nStatusID.length > 0 ? this.FilterGrid.nStatusID.map(e => e.sValue).join(",") : "8,9,10";
    let _sCompanyCode: string = this.FilterGrid.sCompanyCode.length > 0 ? this.FilterGrid.sCompanyCode.map(e => e.COMPANY_CODE).join(",") : "";
    let sDate = "";
    let eDate = "";
    if (this.FilterGrid.dDate.length > 0) {
      sDate = this.System._ParseDateToFormat(this.FilterGrid.dDate[0], "");
    }
    if (this.FilterGrid.dDate.length > 1) {
      eDate = this.System._ParseDateToFormat(this.FilterGrid.dDate[1], "");
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sSearch", this.FilterGrid.sSearch)
        .set("sReqType", _sReqType)
        .set("sStatus", _sStatus)
        .set("sDate", sDate)
        .set("eDate", eDate)
        .set("nUrgent", this.FilterGrid.nUrgent)
        .set("sCompanyCode", _sCompanyCode)
    };

    this.http.get<any>(this.System.SiteName + "api/AdminTask/ListDataTask", httpOptions).toPromise().then(res => {
      if (res) {
        this._ArrData = res;
        this._ArrDataBind = res;
      }
      else {
        this._ArrData = [];
      }
      this.BindDataTable();
    });
  }

  IsApprove: boolean = false;
  BindDataTable() {
    let user = this.System.GetUserStorage();
    let nRole = user.nRole
    let status = this.Getstatus(nRole);
    this.OptionGrid.nTotalItem = this._ArrData.length;

    let nPageSize = this.System.ParseIntToZero(this.OptionGrid.nPageSize)
    let nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * nPageSize;
    let nEndIndex_Take = nPageSize;
    this._ArrDataBind = [];
    this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({}, val)));
    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);

    let nStartItemPage = nStartIndex_Take + 1;
    let nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = "Showing " + nStartItemPage + " to " + nLastItemPage + " of " + this._ArrData.length + " Rows";
    this.System.UnBlockUI();
  }

  async EditData(_Item) {
    let user = this.System.GetUserStorage();
    let nRole = user.nRole
    let nStatus = _Item.nStatusID
    let sUrl = "";
    switch (nRole) {
      case 1://Admin
        sUrl = "admin-adjust";
        break;
      case 2://SSC
        switch (nStatus) {
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 7:
          case 10:
            sUrl = "approve";
            break;
          case 6://Wait Doc Receiving
            sUrl = "admin-receivingdoc";
            break;
          case 8://Wait Adjust Invoice
            sUrl = "admin-adjust";
            break;
          case 9://Wait Export to SAP
            sUrl = "admin-adjust";
            break;
          case 11://Wait Supporting Document
            sUrl = "exportto-sap";
            break;
          case 12://Complete
            sUrl = "approve";
            break;
        }
        break;
      case 3://Approve1
      case 4://Approve2
        sUrl = "approve";
        break;
      case 5://Request
        switch (nStatus) {
          case 1:
          case 3:
          case 5:
          case 7:
          case 10:
            sUrl = this.GetpathTReq(_Item.nReqType);
            break;
          case 2:
          case 4:
          case 6:
          case 8:
            sUrl = "/approve";
            break;
        }
        break;
    }


    //let ID = await this.System.Encrypt(_Item.sRequestID);
    //await this.router.navigate([sUrl], { queryParams: { str: ID } });

    let ID = await this.System.Encrypt(_Item.sRequestID);
    let URL = sUrl + "?str=" + ID;
    window.open(URL, '_blank');
  }
  //#endregion

  //path at status =1
  GetpathTReq(nReqType: number) {
    let sUrl = "";
    switch (nReqType) {
      case 10:
      case 11:
        sUrl = "/paytovendor";
        break;
      case 12:
        sUrl = "/paytoemp";
        break;
      case 20:
        sUrl = "/advancerequest";
        break;
      case 30:
        sUrl = "/clearadvance";
        break;
      case 40:
        sUrl = "/pettycash";
        break;
      case 50:
        sUrl = "/other";
        break;
      case 60:
      case 61:
        sUrl = "/cntype";
        break;
      case 70:
      case 71:
        sUrl = '/billingtocash';
        break;
      case 80:
        sUrl = '/journalvoucher';
        break;
      case 90:
        sUrl = '/receiptvoucher';
        break;
    }
    return sUrl;
  }

  Getstatus(nRole: number) {
    let status = [];
    switch (nRole) {
      case 1:
        status.push(1, 2, 3)
        break
      case 2:
        status.push(2)
        break
    }
    return status;
  }

  GetColorText(_Item: any) {
    let sColor: string = "";
    switch (_Item.nStatusID) {
      case 12:
        sColor = "_text_green_paster";
        break;
      case 3:
      case 5:
      case 7:
      case 10:
        sColor = "_text_red_paster";
        break;
    }
    return sColor;
  }

  numberOnly(event): boolean { //method กรอกข้อมูลเฉพาะตัวเลข
    const charCode = event.key;
    var regExp = new RegExp('[A-Za-z]', 'g');
    if (regExp.test(charCode)) {
      return false;
    } else {
      return true;
    }
  }

  onClick(value: string) {
    let _this = this;
    if (value == "Back") {
      this.router.navigate(["/admin-menu"]);
    }
  }

  async seeItem(template: TemplateRef<any>, sRequestID) {
    let ItemData = { sRequestID: sRequestID }
    let sendData = JSON.stringify(ItemData)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let data: any;
    if (sendData != null) {
      await this.http.post(this.System.SiteName + "api/Home/_GetRequestItems", sendData, { headers, responseType: 'text' }).toPromise().then(Data => data = Data)
      this.arrGL = JSON.parse(data);
    }
    const config: ModalOptions = { class: 'gray modal-xl' };
    this.modalRef = this.modalService.show(template, config);
  }

  onClear() {
    this.FilterGrid.sSearch = "";
    this.FilterGrid.nReqType = [];
    this.FilterGrid.nStatusID = [{ "sValue": 8, "sText": "Waiting Verify" }];
    this.FilterGrid.dDate = [];
    this.FilterGrid.nUrgent = "";
    let ua = this.System.GetUserStorage();
    if (ua) {
      this.FilterGrid.sCompanyCode = [];
      ua.lstCompCode.forEach(f =>
        this.FilterGrid.sCompanyCode.push({ COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName })
      );
    }
    this.loadData();
  }
}
